// eslint-disable-next-line
import _ from 'lodash'
import { buildUserQuery, buildContentQuery } from '../Actions/Content'

export const GENERATE_CONTENT_REPORT = 'GENERATE_CONTENT_REPORT'
export const GENERATE_USER_REPORT = 'GENERATE_USER_REPORT'
export const LOAD_GENERATE_CONTENT_REPORT = 'LOAD_GENERATE_CONTENT_REPORT'
export const LOAD_GENERATE_USER_REPORT = 'LOAD_GENERATE_USER_REPORT'
export const GENERATE_SMS_USERS_REPORT = 'GENERATE_SMS_USERS_REPORT'
export const LOAD_SMS_USERS_REPORT = 'LOAD_SMS_USERS_REPORT'

/**
  * generateContentReport
  * @desc generate a User Report request action
  * @param {string} ID account ID
  * @param {timestamp} start start date
  * @param {timestmap} end end date
  * @param {string} location Content section
  * @param {string} sortField field to sort by
  * @param {string} sortDirection direction to sort by
  * @param {Object} options query options
  * @return {action} generateContentReportAction
*/
export function generateContentReport (ID, start, end, location, sortField, sortDirection, options) {
  const query = buildContentQuery({ accountId: ID, startDate: start, endDate: end, location, sortField, sortDirection }, options)
  return { type: GENERATE_CONTENT_REPORT, query }
}

/**
 * loadGenerateContentReport
 * @desc generate a load content report request action
 * @param data
 * @returns {{data: *, type: string}}
 */
export function loadGenerateContentReport (data) {
  return { type: LOAD_GENERATE_CONTENT_REPORT, data }
}

/**
  * generateUserReport
  * @desc generate a User Report request action
  * @param {string} ID account ID
  * @param {timestamp} start start date
  * @param {timestmap} end end date
  * @param {Object} options query options
  * @return {action} generateUserReportAction
*/
export function generateUserReport (ID, start, end, options) {
  const query = _.merge({ accountId: ID, startDate: start, endDate: end }, buildUserQuery(options))
  return { type: GENERATE_USER_REPORT, query }
}

/**
 * loadGenerateUserReport
 * @desc generate a load user report request action
 * @param data
 * @returns {{data: *, type: string}}
 */
export function loadGenerateUserReport (data) {
  return { type: LOAD_GENERATE_USER_REPORT, data }
}
/**
 * generateSMSUsersReport
 * @desc generate a SMS User Report request action
 * @param {string} alertId alert ID
 * @param {boolean} subscribed subscribed or unsubscribed users
 * @param {number} limit batch size
 * @param {number} offset 0 to start
 */
export function generateSMSUsersReport (alertId, subscribed, limit, offset) {
  const query = { alertId, subscribed, limit, offset }
  return { type: GENERATE_SMS_USERS_REPORT, query }
}
/**
 * loadSMSUsersReport
 * @desc generate a load sms user report request action
 * @param data
 * @returns {{data: *, type: string}}
 */
export function loadSMSUsersReport (data) {
  return { type: LOAD_SMS_USERS_REPORT, data }
}
